import 'view/css/clients.css';

import moment from 'moment';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretDown,
  faCaretUp,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons';

import BasePageView from 'view/BasePageView';
import Form from 'component/Form';
import Protected from 'component/Protected';
import VehicleRow from 'component/VehicleRow';
import ContactGroupEdit from 'component/ContactGroupEditor';
import Paginator from 'component/Paginator';

import API from 'service/api';
import Util from 'service/util';
import ClientFilterBar from 'component/ClientFilterBar';

const defaultFilter = {
  company: '', license: '', client:'',
  worker:'', mod_by: '', service:'', vhType:'',
  weekdays: { 1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false },
  outlook: '', rot: '', remarks: '',
  is_mobill: '', is_rtn_envelope: '', is_print_bill: '',
  fee_min: 0, fee_max: 0, exfee_min: 0, exfee_max: 0,
  srv_dis: '', srv_loc: '', contact: '',
  active: true
};


// helper function
const _xvs = (x) => x.v.activeService || x.v.recentService;

// main class
class ClientListView extends BasePageView
{
  constructor(props)
  {
    super(props);
    this.state = {
      is_show_search: false,
      exporting: false,
      clients: [],
      licenses: [],
      filter: {...defaultFilter},
      sort_by: false,
      page: 1,
      page_count: 200
    };

    this.sort  = this.sort.bind(this);
    this.title = this.title.bind(this);

    this.selectLicense = this.selectLicense.bind(this);
    this.showModal     = this.showModal.bind(this);
    this.closeModal    = this.closeModal.bind(this);
    this.submitModal   = this.submitModal.bind(this);
    this.forceUpdate   = this.forceUpdate.bind(this);

  }
  componentDidMount()
  {
    API.getCustomerList().then(clients => {
      let licenses = new Set();
      clients.forEach(c => c.vehicles.forEach(v => {
        licenses.add(v.cd_license);
        let a = v.activeService || v.recentService;
        if (a) {
          a.loc_key = `${a.srv_dis}${a.srv_loc}`;
        }
        v.services?.forEach(s => s.loc_key = `${s.srv_dis}${s.srv_loc}`);
      }));
      licenses = Array.from(licenses);
      licenses.sort();
      this.setInitiated({clients, licenses});
    }).catch(ex => this.setError());
  }

  showModal(vehicle, customer)
  {
    let modal = {
      error: '',
      ori_vehicle: vehicle,  vehicle:  {...vehicle},
      ori_customer: customer, customer: {...customer},
    };
    this.setState({modal});
  }
  closeModal()
  {
    let { vehicle, ori_vehicle, customer, ori_customer } = this.state.modal;
    Object.assign(vehicle, ori_vehicle);
    Object.assign(customer, ori_customer);
    this.setState({ modal: null });
  }
  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let { vehicle, ori_vehicle, customer, ori_customer } = this.state.modal;

    API.editCustomer(customer, vehicle).then( resp => {
      if (resp.success)
      {
        // copy data
        Object.assign(ori_vehicle,  vehicle);
        Object.assign(ori_customer, customer);
        this.closeModal();
      } else {
        let modal = this.state.modal;
        modal.error = resp.msg;
        this.setState({modal});
      }
    });

    return false;
  }

  setCust(key, value)
  {
    let modal = this.state.modal;
    modal.customer[key] = value;
    this.setState({modal});
  }
  setVehicle(key, value)
  {
    let modal = this.state.modal;
    modal.vehicle[key] = value;
    this.setState({modal});
  }

  exportXls()
  {
    this.setState({exporting: true});
    let filter = { ...this.state.filter };
    filter.srv_loc = filter.srv_loc || null;
    API.exportClientList(filter).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `車輛資料_${ix_date}.xlsx`);
      this.setState({exporting: false});
    });
  }

  sort(scope, key)
  {
    this.setState((s,p) => {
      let order = s.sort_by.key===key?-s.sort_by.order:1;
      return { sort_by: { scope, key, order } };
    });
  }

  isNoData() { return 1>this.state.licenses.length; }
  title = () => <>
    <span className="main-title">基本資料</span> - <span className="sub-title">車主及車輛</span>
  </>

  selectLicense(license)
  {
    let filter = {...defaultFilter, license };
    this.setState({filter});
  }

  getFilteredItems()
  {
    // copy filter
    const F = {...this.state.filter};

    // clean-up filter content
    F.client  = F.client.trim().toLowerCase();
    F.worker  = F.worker.trim().toLowerCase();
    F.mod_by  = F.mod_by.trim().toLowerCase();
    F.outlook = F.outlook.trim().toLowerCase();
    F.rot     = F.rot.trim().toLowerCase();

    let _items = [];
    let _clients = this.state.clients;

    // collect clients by license plate
    if (F.license) {
      _clients = _clients.filter(c => {
        for (let i = 0; i < c.vehicles.length; i++)
          if (-1 < c.vehicles[i].cd_license.indexOf(F.license)) return true;
        return false;
      });
    }

    // collect active clients
    if (F.active) {
      _clients = _clients.filter(c => {
        for (let i = 0; i < c.vehicles.length; i++)
          if (c.vehicles[i].activeService) return true;
        return false;
      });
    }

    // weekdays filter
    {
      let dcnt = Object.values(F.weekdays).reduce((r,x)=>x?++r:r,0);
      if (dcnt > 0)
      {
        _clients = _clients.filter(c => {
          for (let i = 0; i < c.vehicles.length; i++)
          {
            let actsrv = c.vehicles[i].activeService;
            let rctsrv = c.vehicles[i].recentService;
            if (actsrv) {
              if (actsrv.srv_plan === 'A') return true;
              if ( F.weekdays[actsrv.weekday1] ) return true;
              if ( F.weekdays[actsrv.weekday2] ) return true;
              if ( F.weekdays[actsrv.weekday3] ) return true;
            }
            if (rctsrv) {
              if (rctsrv.srv_plan === 'A') return true;
              if ( F.weekdays[rctsrv.weekday1] ) return true;
              if ( F.weekdays[rctsrv.weekday2] ) return true;
              if ( F.weekdays[rctsrv.weekday3] ) return true;
            }
          }
          return false;
        });
      }
    }

    // company filter
    if (F.company) {
      _clients = _clients.filter(c => {
        for (let i = 0; i < c.vehicles.length; i++)
          if (c.vehicles[i].activeService?.company == F.company) return true;
        return false;
      });
    }

    // filter client by contact phone / email / address
    if (F.contact)
    {
      _clients = _clients.filter(c => {
        for (let i = 0; i < c.contacts.length; i++)
          if (-1 < c.contacts[i].c_num.indexOf(F.contact)) return true;
        return false;
      });
    }

    // filter by clients
    if (F.client) {
      if (F.client[0] !== '#')
        _clients = _clients.filter(c => -1<c.display_name.toLowerCase().indexOf(F.client) );
      else {
        let _id = 0;
        if (_id = parseInt(F.client.substring(1), 10))
          _clients = _clients.filter(c => c.id == _id);
      }
    }
    if (F.mod_by)  _clients = _clients.filter(c => -1<c.mod_by.toLowerCase().indexOf(F.mod_by));
    if (F.remarks) _clients = _clients.filter(c => -1<c.remarks?.toLowerCase().indexOf(F.remarks));

    if (F.is_mobill)       _clients = _clients.filter(c => c.is_mobill       === Boolean(+F.is_mobill));
    if (F.is_rtn_envelope) _clients = _clients.filter(c => c.is_rtn_envelope === Boolean(+F.is_rtn_envelope));
    if (F.is_print_bill)   _clients = _clients.filter(c => c.is_print_bill   === Boolean(+F.is_print_bill));

    if (F.create_dtm_min) _clients = _clients.filter(c => moment(c.create_dtm).isSameOrAfter(F.create_dtm_min) );
    if (F.create_dtm_max) _clients = _clients.filter(c => moment(c.create_dtm).isSameOrBefore(F.create_dtm_max) );
    if (F.mod_dtm_min)    _clients = _clients.filter(c => moment(c.mod_dtm).isSameOrAfter(F.mod_dtm_min) );
    if (F.mod_dtm_max)    _clients = _clients.filter(c => moment(c.mod_dtm).isSameOrBefore(F.mod_dtm_max) );

    //-- obtain all vehicles
    _clients.forEach(c => c.vehicles.forEach(v => _items.push({c,v}) ));

    // filter by vehicle and active services
    if (F.service)   _items = _items.filter(x => _xvs(x)?.srv_plan == F.service);
    if (F.vhType)    _items = _items.filter(x => x.v.vh_type == F.vhType);

    // filter by location
    if (F.srv_loc)
      _items = _items.filter(x =>
           _xvs(x)?.srv_dis == F.srv_dis
        && _xvs(x)?.srv_loc == F.srv_loc
      );
    else
    if (F.srv_dis)
      _items = _items.filter(x => _xvs(x)?.srv_dis == F.srv_dis);

    if (F.srv_floor) _items = _items.filter(x => -1<_xvs(x)?.srv_floor?.indexOf(F.srv_floor));
    if (F.srv_psn)   _items = _items.filter(x => -1<_xvs(x)?.srv_psn?.indexOf(F.srv_psn));
    if (F.worker)    _items = _items.filter(x => -1<_xvs(x)?.worker_name?.toLowerCase().indexOf(F.worker));
    if (F.rot)       _items = _items.filter(x => -1<_xvs(x)?.rotation?.toLowerCase().indexOf(F.rot));
    if (F.outlook)   _items = _items.filter(x => {
      if ( -1<x.v.color?.toLowerCase().indexOf(F.outlook) ) return true;
      if ( -1<x.v.brand?.toLowerCase().indexOf(F.outlook) ) return true;
      if ( -1<x.v.model?.toLowerCase().indexOf(F.outlook) ) return true;
      return false;
    });

    if (F.fee_min)   _items = _items.filter(x => F.fee_min   <= _xvs(x)?.fee);
    if (F.fee_max)   _items = _items.filter(x => F.fee_max   >= _xvs(x)?.fee);
    if (F.exfee_min) _items = _items.filter(x => F.exfee_min <= _xvs(x)?.extra_fee);
    if (F.exfee_max) _items = _items.filter(x => F.exfee_max >= _xvs(x)?.extra_fee);

    // client recount
    let dict = {};
    _items.forEach(i => { if (!dict[i.c.id]) { dict[i.c.id] = i.c; } });
    _clients = Object.values(dict);

    return {_clients, _items};
  }

  _render()
  {
    // filters
    let {_clients, _items} = this.getFilteredItems();

    // sort
    if (this.state.sort_by)
    {
      let s_scope = this.state.sort_by.scope;
      let s_key   = this.state.sort_by.key;
      let s_order = this.state.sort_by.order;
      _items.sort((a,b) => {
        let x, y;
        switch (s_scope) {
          case 'c':
          case 'v':
            [x, y] = [ a[s_scope][s_key], b[s_scope][s_key] ];
            break;
          case 's':
            [x, y] = [ _xvs(a)?.[s_key]||'', _xvs(b)?.[s_key]||'' ];
            break;
          default:
            break;
        }
        if (x > y) return  s_order;
        if (x < y) return -s_order;
        return 0;
      });
    }

    // cut down scale
    let Ncust     = this.state.clients.length;
    let Nvh       = this.state.clients.reduce((r,c) => r+c.vehicles.length, 0);
    let Nfcust    = _clients.length;
    let Nfvh      = _items.length;

    // page
    let idx_start = (this.state.page-1) * this.state.page_count;
    let idx_end   = idx_start + this.state.page_count;
    _items = _items.slice(idx_start, idx_end);

    // render
    return (
      <>
        <div className="row action-panel">
          <span className="dummy"></span>
          <div>
            <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
              <button className="btn dark-green btn-export" disabled={this.state.exporting}
                onClick={e=>this.exportXls()}>
                <FontAwesomeIcon icon={faFileExcel} />
                <span> 匯出</span>
              </button>
            </Protected>
          </div>
        </div>
        <div className={'hidding search-bar box '+(this.state.is_show_search?'expand':'')}>
          <h4 className="box-head">
            <span>搜尋</span>
            <div className="button-group">
              <div className="btn-hide" onClick={e=>this.setState({is_show_search: !this.state.is_show_search})}>
              { this.state.is_show_search
                ?<FontAwesomeIcon icon={faCaretDown} />
                :<FontAwesomeIcon icon={faCaretUp} />
              }
              </div>
            </div>
          </h4>
          <div className="box-body">
            <ClientFilterBar filter={this.state.filter} onApply={ this.forceUpdate } />
            <div>
              <div>客戶總數：{ Ncust.toLocaleString() }車主 / { Nvh.toLocaleString() }車輛</div>
              <div>搜尋客戶：{ Nfcust.toLocaleString() }車主 / { Nfvh.toLocaleString() }車輛</div>
            </div>
          </div>
        </div>
        <div className="customers">
          <table className="data-table full-width">
            <colgroup>
              <col width="20px"  id="col-cust-sel"/>
              <col width="60px"  id="col-cust-company"/>
              <col width="100px" id="col-cust-license"/>
              <col width="auto"  id="col-cust-owner"/>
              <col width="50px"  id="col-cust-location"/>
              <col width="50px"  id="col-cust-service"/>
              <col width="50px"  id="col-cust-vhtype"/>
              <col width="200px" id="col-cust-rot"/>
              <col width="60px"  id="col-cust-mo-fee"/>
              <col width="60px"  id="col-cust-extra-fee"/>
              <col width="80px"  id="col-cust-worker"/>
              <col width="100px" id="col-cust-create-date"/>
              <col width="100px" id="col-cust-mod-date"/>
              <col width="80px"  id="col-cust-mod-by"/>
              <col width="60px"  id="col-cust-btn-grp"/>
            </colgroup>
            <thead>
              <tr className="table-row">
                <th className="col-cust-sel"></th>
                <th className="col-cust-company"          onClick={ e => this.sort('s', 'company')      }>公司</th>
                <th className="col-cust-license"          onClick={ e => this.sort('v', 'cd_license')   }>車牌</th>
                <th className="col-cust-owner"            onClick={ e => this.sort('c', 'display_name') }>車主</th>
                <th className="col-cust-location"         onClick={ e => this.sort('s', 'loc_key')      }>地點</th>
                <th className="col-cust-service-plan"     onClick={ e => this.sort('s', 'srv_plan')     }>服務</th>
                <th className="col-cust-vehicle-type"     onClick={ e => this.sort('v', 'vh_type')      }>車種</th>
                <th className="col-cust-service-rotation" onClick={ e => this.sort('s', 'rotation')     }>附加項目</th>
                <th className="col-cust-service-fee"      onClick={ e => this.sort('s', 'fee')          }>月費</th>
                <th className="col-cust-service-exfee"    onClick={ e => this.sort('s', 'extra_fee')    }>附加費</th>
                <th className="col-cust-worker-name"      onClick={ e => this.sort('s', 'worker_name')  }>工人</th>
                <th className="col-cust-create-date"      onClick={ e => this.sort('c', 'create_dtm')   }>開戶日期</th>
                <th className="col-cust-mod-date"         onClick={ e => this.sort('c', 'mod_dtm')      }>修改日期</th>
                <th className="col-cust-mod-by"           onClick={ e => this.sort('c', 'mod_by')       }>修訂人</th>
                <th className="col-cust-btn-grp"></th>
              </tr>
            </thead>
            <tbody>
              { _items.map(({c,v}) =>
                  <VehicleRow key={`v-${c.id}-${v.cd_license}`} customer={c} vehicle={v}
                              onSelectLicense={ this.selectLicense }
                              showModal={ this.showModal }/>)
              }
            </tbody>
          </table>
        </div>
        <nav className="paginator">
          <Paginator itemsCount={Nfvh} pageCount={this.state.page_count}
                     page={this.state.page} key={this.state.page}
                     onSetPage={page=>this.setState({page})} />
        </nav>
        { !this.state.modal?''
          :<div className="modal client-list">
            <div className="modal-box">
              <h2 className="modal-head">編輯 - {this.state.modal.vehicle.cd_license}</h2>
              <Form className="modal-body" onSubmit={this.submitModal}>
                <div className="split">
                  <section>
                    <h4>車主</h4>
                    <label className="field">
                      <strong>賬單名稱</strong>
                      <input type="text" value={this.state.modal.customer.display_name}
                             onChange={e=>this.setCust('display_name', e.target.value)}/>
                    </label>
                    <label className="field">
                      <strong>Whatsapp</strong>
                      <input type="text" value={this.state.modal.customer.whatsapp}
                             placeholder="預留自動寄出賬單用"
                             onChange={e=>this.setCust('whatsapp', e.target.value)}/>
                    </label>
                    <label className="field">
                      <strong>電郵地址</strong>
                      <input type="text" value={this.state.modal.customer.email}
                             placeholder="預留自動寄出賬單用"
                             onChange={e=>this.setCust('email', e.target.value.trim().toLowerCase())}/>
                    </label>
                    <label className="field">
                      <strong>備註</strong>
                      <textarea className="f-remarks" value={this.state.modal.customer.remarks}
                        onChange={e=>this.setCust('remarks', e.target.value)}
                      ></textarea>
                    </label>
                    <label className="field">
                      <strong>聯絡方法</strong>
                      <ContactGroupEdit contacts={this.state.modal.customer.contacts} />
                    </label>
                  </section>
                  <section>
                    <h4>車輛 ({this.state.modal.vehicle.cd_license})</h4>
                    <label className="field">
                      <strong>顏色</strong>
                      <input type="text" value={this.state.modal.vehicle.color}
                              onChange={e=>this.setVehicle('color', e.target.value)}/>
                    </label>
                    <label className="field">
                      <strong>品牌</strong>
                      <input type="text" value={this.state.modal.vehicle.brand}
                              onChange={e=>this.setVehicle('brand', e.target.value)}/>
                    </label>
                    <label className="field">
                      <strong>型號</strong>
                      <input type="text" value={this.state.modal.vehicle.model}
                              onChange={e=>this.setVehicle('model', e.target.value)}/>
                    </label>
                    <div className="split-3">
                      <label className="field">
                        <strong>月結</strong>
                        <input type="checkbox" value={this.state.modal.customer.is_mobill}
                               onChange={e=>this.setCust('is_mobill', e.target.checked)}/>
                      </label>
                      <label className="field">
                        <strong>印收費單</strong>
                        <input type="checkbox" value={this.state.modal.customer.is_rtn_envelope}
                               onChange={e=>this.setCust('is_print_bill', e.target.checked)}/>
                      </label>
                      <label className="field">
                        <strong>回郵信封</strong>
                        <input type="checkbox" value={this.state.modal.customer.is_rtn_envelope}
                               onChange={e=>this.setCust('is_rtn_envelope', e.target.checked)}/>
                      </label>
                    </div>
                  </section>
                </div>
                {
                  !this.state.modal.error?'':<div className="error-msg">{ this.state.modal.error }</div>
                }
                <div className="action-panel">
                  <button className="btn grey" type="button"
                          onClick={e=>this.closeModal()}>關閉</button>
                  <button id="btn-submit" className="btn blue" >確定</button>
                </div>
              </Form>
            </div>
          </div>
        }
      </>
    );
  } // render()

} // end class

export default ClientListView;